// extracted by mini-css-extract-plugin
export default {"content":"src-views-analytics-components-StoriesKPIs-StoriesKPIs__content--tvROi"};